<template>
    <base-page>
      <el-card style="margin: 5px 0px 5px 0px">
        <el-collapse accordion style="border: none">
          <el-collapse-item name="1" style="border: none">
            <template slot="title">
              <div slot="header" class="clearfix">
                <titlu-pagina
                  Titlu="Raport produse"
                />
              </div>
            </template>
        <div class="filtre">
          <el-form @submit.prevent="refresh_info()">
            <el-row style="margin: 10px" class="input-group">
              <el-col class="input-element" :md="12">
                 <el-form-item label='Interval' size="mini">
                   <br>
                    <el-date-picker      
                        v-model="Filters.Data"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="Data inceput"
                        end-placeholder="Data sfarsit"
                        :picker-options="datePickerOptions"
                        format="dd/MM/yyyy" value-format="yyyy-MM-dd" />
                </el-form-item>
              </el-col>
              <el-col class="input-element" :md="12">
                <el-form-item label='Centru productie' size="mini" >
                    <el-select class='full-width' v-model='Filters.IdCentruProductie' filterable >
                        <el-option label='Toate' value='-1'></el-option>
                        <el-option v-for='item in Info.centre_productie' :key="'centre_productie' + item.Id" :label='item.Nume' :value='item.Id'/>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col class="input-element" :md="12">
                <el-form-item label='Serviciu programator'  size="mini">
                    <el-select class='full-width' v-model='Filters.IdServiciuProgramator' filterable >
                        <el-option label='Toate' value='-1'></el-option>
                        <el-option v-for='item in Info.servicii_programator' :key="'serviciu_programator' + item.Id" :label='item.Nume' :value='item.Id'/>
                    </el-select>
                </el-form-item>
              </el-col>   
              <el-col  class="input-element" :md="12">
                <el-form-item label='Mecanic/Ajutor' size="mini">
                  <div class="input-group full-width"> 
                    <el-select class='full-width' v-model='Filters.IdMecanic' filterable >
                        <el-option label='Toti' value='-1'></el-option>
                        <el-option-group key="Activi">
                          <el-option v-for='item in Info.mecanici' :key="'mecanici' + item.Id" :label='item.Nume' :value='item.Id' />
                        </el-option-group>
                        <el-option-group v-if="Filters.ArataMecaniciInactivi==1" key="Inactivi" label="Inactivi">
                          <el-option v-for='item in Info.mecanici_inactivi' :key="'mecanici_inactivi' + item.Id" :label='item.Nume' :value='item.Id'/>
                        </el-option-group>
                        <el-option-group v-if="Filters.ArataMecaniciStersi==1" key="Stersi" label="Stersi">
                          <el-option v-for='item in Info.mecanici_stersi' :key="'mecanici_stersi' + item.Id" :label='item.Nume' :value='item.Id'/>
                        </el-option-group>
                    </el-select>
                    <div class="input-group-append">
                      <el-checkbox size="mini"
                          v-model="Filters.ArataMecaniciInactivi"
                          true-label="1"
                          false-label="0"
                          @change="schimbaListaMecanici()"
                        >
                          <small>Arata inactivi</small>
                        </el-checkbox>
                        <el-checkbox size="mini"
                          v-model="Filters.ArataMecaniciStersi"
                          true-label="1"
                          false-label="0"
                          @change="schimbaListaMecaniciStersi()"
                        >
                          <small>Arata stersi</small>
                        </el-checkbox>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col class="input-element" :md="12">
                <el-form-item label='Status' size="mini">
                    <el-select class='full-width' v-model='Filters.Status' filterable multiple>
                        <el-option label='Aprobate' value='Aprobat'></el-option>
                        <!-- <el-option label='Draft' value='Draft'></el-option>  --> <!-- daca punen draft trebuie scoasa conditia din sql sa aiba DataTerminareLucru -->
                        <el-option label='In validare' value='In_validare'></el-option>
                        <el-option label='Facturate' value='Facturat'></el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="24">
                <el-button
                  type="primary"
                  native-type="submit"
                  @click="refresh_info()"
                  size="mini">
                  Aplica
                </el-button>
                <el-button type="danger" native-type="submit" @click="reset()" size="mini">
                  Reseteaza
                </el-button>
              </el-col>
            </el-row>
          </el-form>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>

      <div v-if="NrDevizePenalizate > 0" style="margin: 10px 0;">
        <el-alert
          :title="'Atentie: Au fost excluse ' + NrDevizePenalizate + ' devize penalizate din acest raport conform filtrelor selectate.'"
          type="warning"
          show-icon
          :closable="false">
        </el-alert>
      </div>

      <el-table :data="Results" style="width: 100%" id="my-table">
        <el-table-column type="expand" align="center">
          <template slot-scope="scope">
            <el-table :data="scope.row.produse" style="width: 96%; margin-left: 4%;">
              <el-table-column prop="numeProdus" label="Nume"></el-table-column>
              <el-table-column prop="cantitate" label="Cantitate"></el-table-column>
              <el-table-column prop="timpMontaj" label="Timp montaj (s)"></el-table-column>
              <el-table-column prop="costMontaj" label="Cost montaj unitar"></el-table-column>
              <el-table-column prop="costMontajTotal" label="Cost montaj total" :render-header="renderHeader"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="mecanic" label="Mecanic"></el-table-column>
        <el-table-column prop="totalCost" label="Total cost montaj" :render-header="renderHeader"></el-table-column>
        <el-table-column prop="totalCostServicii" label="Total servicii" :render-header="renderHeader"></el-table-column>

        <el-table-column label="Penalizari" :render-header="renderHeader">
            <template slot-scope="scope">
                <span v-if="scope.row.totalPenalizari > 0" style="color:red; font-weight:bold;">
                    -{{ scope.row.totalPenalizari }} RON
                </span>
                <span v-else>0 RON</span>
            </template>
        </el-table-column>

        <el-table-column label="Rest" :render-header="renderHeader">
            <template slot-scope="scope">
                <span style="font-weight:bold; font-size: 1.1em;">
                    {{ scope.row.totalDePlata }} RON
                </span>
            </template>
        </el-table-column>
       
      </el-table>
      
  
      
  
      <!-- <el-pagination
        @size-change="refresh_info"
        @current-change="refresh_info"
        :page-size.sync="PaginationInfo.PerPage"
        :current-page.sync="PaginationInfo.Page"
        :total="PaginationInfo.RowCount"
        layout="pager"
      /> -->
    </base-page>
  </template>
  
  <script>
  import settings from "@/backend/LocalSettings";
  import BasePage from "@/pages/Admin/BasePage";
  import TitluPagina from "@/widgets/TitluPagina";
  import moment from 'moment';
  
  export default {
    name: "raport_produse",
    extends: BasePage,
    components: {
      "base-page": BasePage,
      "titlu-pagina": TitluPagina,
    },
    data() {
      return {
        datePickerOptions: settings.datePickerOptions,
        dummyResults:[],
        Results: [],
        base_url: "",
        NrDevizePenalizate: 0,
        Info: {
          mecanici:[],
          mecanici_inactivi:[],
          centre_productie:[],
          servicii_programator:[],
        },
        Filters: {
          Data: [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD 23:59:59')],
          IdCentruProductie:'-1',
          IdMecanic:'-1',
          ArataMecaniciInactivi:'0',
          ArataMecaniciStersi:'0',
          IdServiciuProgramator:'-1',
          Status:['Aprobat','In_validare','Facturat'],
        },
        OrderBy: {},
        PaginationInfo: {
          Page: 1,
          PerPage: 50,
          RowCount: 0,
          PageSizes: [10, 25, 50, 100, 200],
        },
        mecNameArray:[],
        Penalizari: {},
      };
    },
    methods: {
      async get_info() {
        var response = await this.post("receptie/devize/get_info_raport_produse");
        this.Info.mecanici = response.mecanici;
        this.Info.mecanici_inactivi = response.mecanici_inactivi;
        this.Info.mecanici_stersi = response.mecanici_stersi;
        this.Info.centre_productie = response.centre_productie;
        this.Info.servicii_programator = response.servicii_programator;
        this.refresh_info();
      },

      renderHeader(h, { column, $index }) {
        return h(
          'span',
          {
            style: {
              fontWeight: 800
            }
          },
          column.label
        );
      },

  
      async refresh_info() {
        var response = await this.post("receptie/devize/get_raport_produse_grupat", {
          Filters: this.Filters,
          OrderBy: this.OrderBy,
        });

        this.NrDevizePenalizate = response.NrDevizePenalizate || 0;
        this.dummyResults = response.Results;
        this.mecanici = response.Mecanici;
        this.mecNameArray=[];
        this.Penalizari = response.Penalizari || {};

        this.mapResultsToMecanici();
        // this.PaginationInfo = response.PaginationInfo;
        
      },
      mapResultsToMecanici() {
        const finalArray = []
        for (const key in this.dummyResults) {
          const id = key;

          const mecanic = this.mecanici.find(m => m.Id == id);
          if (mecanic) {
            let dummyObj = {};

            dummyObj.mecanic = mecanic.Nume + (mecanic.TipUtilizator === 'AjutorMontator' ? ' (ajutor montator)' : '');

            dummyObj.produse = this.dummyResults[key];
            let totalCost = 0;
            let totalCostServicii = 0;
            dummyObj.produse.forEach((produs) => {
              if (produs['serviciu'] == 1) {
                totalCostServicii += produs['cantitate'] * produs['costMontaj'];
              }
              totalCost += produs['cantitate'] * produs['costMontaj'];
            });

            let penalizareMecanic = 0;
            if(this.Penalizari && this.Penalizari[id]){
                penalizareMecanic = parseFloat(this.Penalizari[id]);
            }

            dummyObj.totalCost = totalCost;
            dummyObj.totalCostServicii = totalCostServicii;

            dummyObj.totalPenalizari = penalizareMecanic;
            dummyObj.totalDePlata = totalCost - penalizareMecanic;

            finalArray.push(dummyObj);
          }
        }

        this.Results = [...finalArray];
      },
      schimbaListaMecanici(){
        if(this.Filters.ArataMecaniciInactivi == 0){
          let MecaniculSelectat = this.Info.mecanici_inactivi.filter((value) => value.Id == this.Filters.IdMecanic);
          if(MecaniculSelectat.length > 0)
            if(MecaniculSelectat[0].Dezactivat == 1)   this.Filters.IdMecanic = "-1";
        }
      },  
      schimbaListaMecaniciStersi() {
        if (this.Filters.ArataMecaniciStersi == 0) {
          let mecanicSelectat = this.Info.mecanici_stersi.filter((value) => value.Id == this.Filters.IdMecanic);
          if (mecanicSelectat.length > 0) {
            if (mecanicSelectat[0].Sters == 1) {
              this.Filters.IdMecanic = "-1";
            }
          }
        }
      },
      reset() {
        this.Filters = {
          Data: [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD hh:mm')],
          IdCentruProductie:'-1',
          IdMecanic:'-1',
          ArataMecaniciInactivi:'0',
          ArataMecaniciStersi:'0',
          IdServiciuProgramator:'-1',
          Status:['Aprobat','In_validare','Facturat'],
        };
        this.refresh_info();
      },
  
    },
  
    mounted() {
      this.select_menu_item("raport_produse");
      this.base_url = settings.BASE_URL;
      this.get_info();
    },
  };
  </script>
  
  <style lang="less" scoped>
  .top50 {
    margin-top: 20px;
  }
  
  .input-group {
    display: flex;
    align-items: flex-start;
    // justify-content: space-between;
  }
  
  .filtre {
    .el-input-number {
      width: 100% !important;
    }
  }
  
  
  
  .total {
    width: 100%;
    background-color: white;
    padding: 14px 10px;
    text-align: end;
    font-size: 18px;
  }
  
  
  .input-element {
    width: 23%;
    margin-right: 2%;
  }
  
  @media only screen and (max-width: 600px) {
    .input-element {
      width: 80%;
      
    }
  
    .phone-btn {
      padding-left: 20px;
      position: -webkit-sticky;
      position: sticky;
      top: 0;
    }
  
    .input-group {
      margin: 10px;
    }
  
    .el-tooltip__popper {
      width: 90%;
    }
  
    .el-date-editor--daterange.el-input__inner {
      width: 300px;
    }
  
    .el-picker-panel__body {
      display: flex;
      flex-direction: column;
    }
  }
  </style>
  